module.exports = __webpack_public_path__ + "img/camping.ac789253.jpg";